import { useEffect } from "react";
import { useLanderConfig } from "../commons/ConfigContext";
import { sendErrorEvent } from "../commons/LanderEvent";
import { ErrorCode, System } from "../commons/Constants";
import { LanderConfig } from "../types/LanderConfig";
import { getExpiryPartnerConfig } from "../commons/LanderConfig";

export const rsocRedirect = async (landerConfig: LanderConfig) => {
  try {
    let rsocUrl: URL;
    if (landerConfig.rsoc.url) {
      rsocUrl = new URL(landerConfig.rsoc.url);
    } else {
      rsocUrl = new URL(landerConfig.rsoc.path, "https://www.searchhounds.com");
    }

    // Query params that will be used in searchhounds
    rsocUrl.searchParams.set("psystem", landerConfig.system);
    rsocUrl.searchParams.set("domain", window.location.hostname);

    const expiryPortfolioId = getExpiryPartnerConfig().portfolioId || "";
    if (expiryPortfolioId) rsocUrl.searchParams.set("pid", expiryPortfolioId);

    location.assign(rsocUrl.toString());
  } catch (error) {
    sendErrorEvent(landerConfig, ErrorCode.ERROR_RSOC_REDIRECT);
  }
};

export function useRsoc() {
  const { landerConfig } = useLanderConfig();

  const rsocRedirectEnabled =
    (!!landerConfig.rsoc?.path || !!landerConfig.rsoc?.url) &&
    (landerConfig.system === System.PARKWEB ||
      landerConfig.lander.feedID === 1) &&
    landerConfig.domain?.rootDomain !== "cloudynest.store"; // This domain was reported by Google for paid traffic. This is a temporary fix until we find a better way to detect paid traffic.

  useEffect(() => {
    if (rsocRedirectEnabled) rsocRedirect(landerConfig);
  }, [rsocRedirectEnabled, landerConfig]);

  return { rsocRedirectEnabled };
}
